import BaseAPI from './base/base-api';

class TaxPayerInfoAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'taxpayerinfo';
}

export default new TaxPayerInfoAPI();
